import styled from 'styled-components';

import type { ButtonStyledProps } from './Button.types';

const Button = styled.button<ButtonStyledProps>`
  ${({ theme }) => theme.components.button.base};
  ${({ theme, intent }) => intent && theme.components.button.intent[intent]};

  width: ${({ inline }) => (inline === true ? 'auto' : '100%')};
  height: ${({ height, theme }) =>
    height
      ? theme.components.button.sizes[height]
      : theme.components.button.sizes.m};
  cursor: pointer;

  display: ${({ inline }) => (inline === true ? 'inline-flex' : 'flex')};
  align-items: center;
  justify-content: center;
  white-space: nowrap;
`;

const Leading = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  height: 100%;
  line-height: 0;
  overflow: hidden;
  padding-right: 8px;
`;

const Trailing = styled.div`
  align-items: center;
  display: flex;
  flex: 0 0 auto;
  height: 100%;
  line-height: 0;
  overflow: hidden;
  padding-left: 8px;
`;

export { Button, Leading, Trailing };
